"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "useWindowDimensions", {
    enumerable: true,
    get: function() {
        return useWindowDimensions;
    }
});
const _react = require("react");
const getWindowDimensions = ()=>{
    if (typeof window === "undefined") {
        return {
            width: 0,
            height: 0
        };
    }
    const { innerWidth: width, innerHeight: height } = window;
    return {
        width,
        height
    };
};
const useWindowDimensions = ()=>{
    const [windowDimensions, setWindowDimensions] = (0, _react.useState)(getWindowDimensions());
    (0, _react.useEffect)(()=>{
        function handleResize() {
            setWindowDimensions(getWindowDimensions());
        }
        window.addEventListener("resize", handleResize);
        return ()=>window.removeEventListener("resize", handleResize);
    }, []);
    return windowDimensions;
};

//# sourceMappingURL=useWindowDimensions.js.map